import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Hero: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="home" className="relative h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-neutral-dark bg-opacity-50"></div>
        <img 
          src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" 
          alt="Design de Interiores Elegante" 
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container relative z-10 text-white">
        <div className="max-w-3xl">
          <motion.h1 
            className="text-4xl md:text-6xl font-bold leading-tight mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Transforme Espaços e Negócios com<br />
            Design Estratégico
          </motion.h1>
          
          <motion.div 
            className="text-xl md:text-2xl mb-8 opacity-90"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <p className="mb-2">Consultoria expertise em Design de Interiores e Visual Merchandising</p>
            <p>Cursos de Visual Merchandising online e in Company</p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <a 
              href="https://wa.me/5541999119143?text=Olá,%20gostaria%20de%20agendar%20uma%20consultoria." 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-block"
            >
              Agende uma Consultoria
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : -20 }}
        transition={{ duration: 0.8, delay: 0.8, repeat: Infinity, repeatType: "reverse" }}
      >
        <span className="text-white text-sm mb-2">Explore</span>
        <div className="w-1 h-8 bg-white bg-opacity-60 rounded-full"></div>
      </motion.div>
    </section>
  );
};

export default Hero; 